module.exports = __webpack_public_path__ + "static/Multiple-Axes-76183a7628fb695f9dd68fd49bb03f2a.png";